
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";

const NS = 'PinCtrl';

export default function PinCtrl(
  $mdDialog, accLock, $state
) {
  "ngInject";

  const vm = this;

  vm.enter = enter;
  vm.cancel = cancel;

  ////////////////
  function enter() {
    vm.errorMsg = '';
    // check.
    if (AdminService.checkPin(vm.pin)) {
      accLock ? ManagerService.managerLock(goToBookingPage) : ManagerService.managerUnlock();
      cancel();
    } else {
      // wrong pin
      vm.errorMsg = "Incorrect Pin";
    }
  }

  function goToBookingPage() {
    $state.go('bookings');
  }

  function cancel() {
    $mdDialog.cancel();
  }
}
